import { getAxiosInstance, loadAppConfig } from '@chr/online-shared-microsite-core';
import { LocalConfig } from '../constants/localConfig';
import { GenerateRotpTokenResponse } from '../../common/constants/invoice';

export async function getPaymentAuthToken() : Promise<string> {
  const config = await loadAppConfig() as LocalConfig;
  const axios = await getAxiosInstance();
  const baseUrl = config.gatewayV2ApiUri;
  const url = `${baseUrl}/token`;

  const response = await axios.get<{token: string}>(url);
  return response.data.token;
}

export async function generateRotpTokenAsync(invoiceNum: number, invoiceAmt: number, loadNum: number, token: string, recaptchaType: string): Promise<GenerateRotpTokenResponse> {
  const config = await loadAppConfig() as LocalConfig;
  const axios = await getAxiosInstance();
  const baseUrl = config.gatewayV2ApiUri;
  const url = `${baseUrl}/guest/token`;

  const response = await axios.post<GenerateRotpTokenResponse>(url,
    { InvoiceNum: invoiceNum, InvoiceAmt: invoiceAmt, LoadNum: loadNum },
    { headers: { 'g-recaptcha-response': token, 'g-recaptcha-type': recaptchaType }
  });

  return response.data;
}

export async function redirectToGuestPaymentProcessor(rotpToken: string) {
  const config = await loadAppConfig() as LocalConfig;
  window.location.href = `${config.guestPaymentUrl}?itok=${rotpToken}`;
}
